export default __webpack_public_path__ + "static/media/laptop9.0caaee83.jpeg";